/* eslint-disable no-console */

/*
 *  V 0.1.0 - 2023-05-09
 *
 *  https://medium.com/@dougallrich/give-users-control-over-app-updates-in-vue-cli-3-pwas-20453aedc1f2
 *
 */
import { register } from 'register-service-worker'

if (process.env.NODE_ENV === 'production') {
  register(`${process.env.BASE_URL}service-worker.js?v=${Date.now()}`, {
    ready () {
      console.log('Service worker is active.')
    },
    registered (registration) {
      console.log('Service worker has been registered.')
      console.log(registration)

      // Routinely check for app updates by testing for a new service worker.
      setInterval(() => {
        // ------------------------------------------------------------------------------
        //
        // https://developer.chrome.com/docs/workbox/service-worker-lifecycle/
        //
        // Concerning updates, registration logic generally shouldn't change. Yet, one
        // exception might be if sessions on a website are long - lived.This can happen
        // in single page applications where navigation requests are rare, since the
        // application typically encounters one navigation request at the start of the
        // application's lifecycle.In such situations, a manual update can be triggered
        // on the main thread:
        //
        // navigator.serviceWorker.ready.then((registration) => {
        //   registration.update();
        // });
        //
        // ------------------------------------------------------------------------------

        registration.update()
      }, 1000 * 60 * 60) // hourly checks - 1000 * 60 * 60)  --  1000 * 5
    },
    cached () {
      console.log('Content has been cached for offline use.')
    },
    updatefound () {
      console.log('New content is downloading.')
    },
    updated (registration) {
      console.log('New content is available; please refresh.')
      console.log(registration)

      // Add a custom event and dispatch it.
      // Used to display of a 'refresh' banner following a service worker update.
      // Set the event payload to the service worker registration object.
      document.dispatchEvent(
        new CustomEvent('swUpdated', { detail: registration })
      )
    },
    offline () {
      console.log('No internet connection found. App is running in offline mode.')
    },
    error (error) {
      console.error('Error during service worker registration:', error)
    }
  })
}
